/* Trade-in appraisals — storefront booking + manage page.
 * obg-tools plan docs/superpowers/plans/2026-09-24-trade-in-appraisals-phase2.md, Task 14.
 * Vanilla ES5-compatible JS; talks only to /apps/appraisals/* (Shopify app proxy). */
(function () {
  "use strict";
  var root = document.getElementById("tia-app");
  if (!root) return;
  var PROXY = root.getAttribute("data-proxy") || "/apps/appraisals";
  var params = new URLSearchParams(window.location.search);
  var manageToken = params.get("manage");
  // One formatter for the whole page (Intl.* objects are never built per call).
  var USD = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  var state = {
    config: null,
    mode: "appointment",
    game: "",
    tier: "",
    hv: false,
    days: [],
    dayIndex: 0,
    start: null,
    startLabel: "",
    submissionId: newId(),
    // true when the server/tier rules make this a drop-off-only collection
    // (vs a customer who chose a drop-off voluntarily).
    forcedDropoff: false,
    ack: "",
    form: {
      name: root.getAttribute("data-customer-name") || "",
      email: root.getAttribute("data-customer-email") || "",
      phone: root.getAttribute("data-customer-phone") || "",
      cardEstimate: "",
      notes: "",
    },
  };

  function newId() {
    if (window.crypto && window.crypto.randomUUID)
      return window.crypto.randomUUID();
    var b = new Uint8Array(16);
    window.crypto.getRandomValues(b);
    b[6] = (b[6] & 15) | 64;
    b[8] = (b[8] & 63) | 128;
    var hex = Array.prototype.map
      .call(b, function (x) {
        return (x + 256).toString(16).slice(1);
      })
      .join("");
    return (
      hex.slice(0, 8) +
      "-" +
      hex.slice(8, 12) +
      "-" +
      hex.slice(12, 16) +
      "-" +
      hex.slice(16, 20) +
      "-" +
      hex.slice(20)
    );
  }

  function h(tag, attrs) {
    var el = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (v === null || v === undefined || v === false) return;
        if (k === "text") el.textContent = v;
        else if (k === "class") el.className = v;
        else if (k.indexOf("on") === 0) el.addEventListener(k.slice(2), v);
        else if (v === true) el.setAttribute(k, "");
        else el.setAttribute(k, v);
      });
    }
    for (var i = 2; i < arguments.length; i++) append(el, arguments[i]);
    return el;
  }
  function append(el, c) {
    if (c === null || c === undefined || c === false) return;
    if (Array.isArray(c))
      return c.forEach(function (x) {
        append(el, x);
      });
    el.appendChild(typeof c === "string" ? document.createTextNode(c) : c);
  }
  function show(node, scroll) {
    root.innerHTML = "";
    root.appendChild(node);
    if (scroll) root.scrollIntoView({ block: "start", behavior: "smooth" });
  }

  function api(path, body) {
    var opts = {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    };
    if (body) {
      opts.method = "POST";
      opts.headers["Content-Type"] = "application/json";
      opts.body = JSON.stringify(body);
    }
    return fetch(PROXY + path, opts)
      .then(function (res) {
        return res
          .json()
          .catch(function () {
            return {};
          })
          .then(function (data) {
            return { status: res.status, data: data };
          });
      })
      .catch(function () {
        return { status: 0, data: {} };
      });
  }

  function phone() {
    return state.config && state.config.publicPhone;
  }
  function callUs() {
    return phone() ? "please call us at " + phone() : "please call the store";
  }
  function problem(status) {
    if (status === 429)
      return "Too many tries — please wait a few minutes and try again.";
    return "Online booking is temporarily unavailable — " + callUs() + ".";
  }
  function alertBox(msg, kind) {
    return h("div", {
      class: "tia-alert tia-alert--" + (kind || "error"),
      role: "alert",
      text: msg,
    });
  }
  function button(label, onclick, kind) {
    return h("button", {
      type: "button",
      class: "tia-btn" + (kind ? " tia-btn--" + kind : ""),
      onclick: onclick,
      text: label,
    });
  }
  function busy(btn, on) {
    btn.disabled = on;
    btn.classList.toggle("tia-btn--busy", on);
  }
  function money(cents) {
    return USD.format(cents / 100);
  }
  // "Please call us at …" as a sentence of its own.
  function callUsSentence() {
    var s = callUs();
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  function tierFor(key) {
    return (state.config.tiers || []).filter(function (t) {
      return t.key === key;
    })[0];
  }
  function gameName() {
    var g = (state.config.games || []).filter(function (x) {
      return x.slug === state.game;
    })[0];
    return g ? g.name : "";
  }

  /* ── picker shared by booking and reschedule ─────────────────────────── */
  function picker(days, onPick) {
    var wrap = h("div", { class: "tia-picker" });
    var idx = 0;
    function render() {
      wrap.innerHTML = "";
      append(
        wrap,
        h(
          "div",
          {
            class: "tia-days",
            role: "group",
            "aria-label": "Days with openings",
          },
          days.map(function (d, i) {
            return h("button", {
              type: "button",
              class: "tia-chip" + (i === idx ? " tia-chip--on" : ""),
              "aria-pressed": i === idx ? "true" : "false",
              text: d.label,
              onclick: function () {
                idx = i;
                render();
              },
            });
          }),
        ),
      );
      append(
        wrap,
        h(
          "div",
          { class: "tia-times", role: "group", "aria-label": "Start times" },
          days[idx].times.map(function (t) {
            return h("button", {
              type: "button",
              class: "tia-chip tia-chip--time",
              text: t.label,
              onclick: function () {
                onPick(t.start, days[idx].label + " " + t.label);
              },
            });
          }),
        ),
      );
    }
    render();
    return wrap;
  }

  /* ── booking mode ────────────────────────────────────────────────────── */
  function stepAbout(msg) {
    var c = state.config;
    if (!c.games.length) {
      return show(
        h(
          "div",
          null,
          alertBox(
            "Online booking isn't available right now — " + callUs() + ".",
          ),
        ),
      );
    }
    var game = h(
      "select",
      { id: "tia-game", required: true },
      h("option", { value: "", text: "Choose a game" }),
      c.games.map(function (g) {
        return h("option", {
          value: g.slug,
          text: g.name,
          selected: g.slug === state.game,
        });
      }),
    );
    var tier = h(
      "select",
      { id: "tia-tier", required: true },
      h("option", { value: "", text: "Choose one" }),
      c.tiers.map(function (t) {
        return h("option", {
          value: t.key,
          text: t.label,
          selected: t.key === state.tier,
        });
      }),
    );
    var hv = h("input", { type: "checkbox", id: "tia-hv", checked: state.hv });
    var modeAppt = h("input", {
      type: "radio",
      name: "tia-mode",
      id: "tia-mode-a",
      value: "appointment",
      checked: state.mode === "appointment",
    });
    var modeDrop = h("input", {
      type: "radio",
      name: "tia-mode",
      id: "tia-mode-d",
      value: "dropoff",
      checked: state.mode === "dropoff",
    });
    var modeBox = c.dropoffsOnline
      ? h(
          "fieldset",
          { class: "tia-choice" },
          h("legend", { text: "How would you like to do this?" }),
          h(
            "label",
            { for: "tia-mode-a" },
            modeAppt,
            " Book an appointment — we look at your cards with you",
          ),
          h(
            "label",
            { for: "tia-mode-d" },
            modeDrop,
            " Drop off my cards — leave them with us and get a quote by email",
          ),
        )
      : null;
    var go = button(
      c.dropoffsOnline ? "Continue" : "Find a time",
      function () {
        state.game = game.value;
        state.tier = tier.value;
        state.hv = hv.checked;
        state.mode =
          c.dropoffsOnline && modeDrop.checked ? "dropoff" : "appointment";
        if (!state.game || !state.tier)
          return stepAbout("Pick a game and how many cards you have.");
        var t = tierFor(state.tier);
        var forced =
          t && (state.hv ? t.highValueDropoffOnly : t.standardDropoffOnly);
        state.forcedDropoff = !!forced;
        if (forced) return toDropoff();
        if (state.mode === "dropoff") return stepDropoffDetails();
        busy(go, true);
        api(
          "/availability?game=" +
            encodeURIComponent(state.game) +
            "&tier=" +
            encodeURIComponent(state.tier) +
            "&hv=" +
            (state.hv ? "1" : "0"),
        ).then(function (r) {
          busy(go, false);
          if (r.status !== 200) return stepAbout(problem(r.status));
          if (r.data.kind === "dropoff_only") {
            state.forcedDropoff = true;
            return toDropoff();
          }
          state.days = r.data.days || [];
          stepTimes();
        });
      },
      "primary",
    );
    show(
      h(
        "div",
        { class: "tia-step" },
        h("h2", { text: "About your cards" }),
        msg ? alertBox(msg) : null,
        h("label", { for: "tia-game", text: "Game" }),
        game,
        h("label", { for: "tia-tier", text: "How many cards?" }),
        tier,
        h(
          "label",
          { class: "tia-check", for: "tia-hv" },
          hv,
          " Includes high-value or vintage cards (for example Reserved List cards, WotC-era Pokémon or graded slabs)",
        ),
        h("p", {
          class: "tia-muted",
          text: "High-value appointments take longer and are confirmed by a manager within 1 business day.",
        }),
        modeBox,
        go,
      ),
    );
  }

  // A collection this size can only be a drop-off: register it online when
  // online drop-offs are on, otherwise show the call-us message.
  function toDropoff() {
    if (state.config.dropoffsOnline)
      return stepDropoffDetails(
        "Collections this size are appraised as a drop-off rather than a timed appointment.",
        "ok",
      );
    stepDropoff();
  }

  // Online drop-offs are off. A collection that can only be a drop-off gets the
  // call-us message; a customer who merely chose a drop-off is pointed back to
  // an appointment (voluntary).
  function stepDropoff(voluntary) {
    show(
      h(
        "div",
        { class: "tia-step" },
        h("h2", {
          text: voluntary
            ? "Online drop-offs aren't available"
            : "Let's do this as a drop-off",
        }),
        h("p", {
          text: voluntary
            ? "Online drop-offs aren't available right now — you can book an appointment instead, or bring your cards in during store hours."
            : "Collections this size are appraised as a drop-off rather than a timed appointment. Bring them in during store hours, or " +
              callUs() +
              " and we'll set it up.",
        }),
        button("Back", function () {
          stepAbout();
        }),
      ),
      true,
    );
  }

  function stepTimes() {
    if (!state.days.length) {
      return show(
        h(
          "div",
          { class: "tia-step" },
          h("h2", { text: "No openings right now" }),
          h("p", {
            text:
              "There are no openings for " +
              gameName() +
              " in the next " +
              state.config.horizonDays +
              " days. Please " +
              callUs().replace(/^please /, "") +
              " and we'll find a time.",
          }),
          state.config.dropoffsOnline
            ? button(
                "Drop off my cards instead",
                function () {
                  state.mode = "dropoff";
                  stepDropoffDetails();
                },
                "primary",
              )
            : null,
          button("Back", function () {
            stepAbout();
          }),
        ),
        true,
      );
    }
    show(
      h(
        "div",
        { class: "tia-step" },
        h("h2", { text: "Pick a time" }),
        h("p", {
          class: "tia-muted",
          text:
            gameName() +
            " · " +
            tierFor(state.tier).label +
            (state.hv ? " · high-value" : ""),
        }),
        picker(state.days, function (start, label) {
          state.start = start;
          state.startLabel = label;
          stepDetails();
        }),
        button("Back", function () {
          stepAbout();
        }),
      ),
      true,
    );
  }

  function field(key, label, type, attrs) {
    var input = h(
      type === "textarea" ? "textarea" : "input",
      Object.assign(
        {
          id: "tia-" + key,
          name: key,
          type: type === "textarea" ? null : type,
        },
        attrs || {},
      ),
    );
    input.value = state.form[key] || "";
    input.addEventListener("input", function () {
      state.form[key] = input.value;
    });
    return [h("label", { for: "tia-" + key, text: label }), input];
  }

  function stepDetails(msg, nearest) {
    var honeypot = h("input", {
      type: "text",
      name: "website",
      tabindex: "-1",
      autocomplete: "off",
    });
    var submit = button(
      state.hv ? "Request appraisal" : "Book appraisal",
      function () {
        busy(submit, true);
        api("/appointments", {
          clientSubmissionId: state.submissionId,
          game: state.game,
          tier: state.tier,
          hv: state.hv,
          start: state.start,
          name: state.form.name,
          email: state.form.email,
          phone: state.form.phone,
          cardEstimate: state.form.cardEstimate,
          notes: state.form.notes,
          website: honeypot.value,
        }).then(function (r) {
          busy(submit, false);
          var d = r.data || {};
          if (r.status === 200) {
            state.submissionId = newId();
            return stepResult(d);
          }
          if (d.result === "invalid") return stepDetails(d.message);
          if (d.result === "slot_taken")
            return stepDetails(
              "Sorry — that time was just taken." +
                (d.nearest && d.nearest.length
                  ? " These are the closest openings:"
                  : " Please pick another time."),
              d.nearest,
            );
          if (d.result === "dropoff_only") return toDropoff();
          if (d.result === "email_cap")
            return stepDetails(
              "You already have " +
                d.max +
                " open appraisals or drop-offs with this email. To book another, cancel one from its confirmation email, or " +
                callUs() +
                ".",
            );
          stepDetails(problem(r.status));
        });
      },
      "primary",
    );
    show(
      h(
        "form",
        {
          class: "tia-step",
          novalidate: true,
          onsubmit: function (e) {
            e.preventDefault();
          },
        },
        h("h2", { text: "Your details" }),
        h("p", {
          class: "tia-summary",
          text: gameName() + " · " + state.startLabel,
        }),
        msg ? alertBox(msg) : null,
        nearest && nearest.length
          ? h(
              "div",
              { class: "tia-times" },
              nearest.map(function (n) {
                return h("button", {
                  type: "button",
                  class: "tia-chip tia-chip--time",
                  text: n.label,
                  onclick: function () {
                    state.start = n.start;
                    state.startLabel = n.label;
                    stepDetails();
                  },
                });
              }),
            )
          : null,
        field("name", "Full name", "text", {
          autocomplete: "name",
          maxlength: "120",
          required: true,
        }),
        field("email", "Email", "email", {
          autocomplete: "email",
          required: true,
        }),
        field("phone", "Phone", "tel", { autocomplete: "tel", required: true }),
        field("cardEstimate", "Roughly how many cards? (optional)", "text", {
          maxlength: "60",
        }),
        field("notes", "Anything we should know? (optional)", "textarea", {
          maxlength: "1000",
          rows: "3",
        }),
        h(
          "div",
          { class: "tia-hp", "aria-hidden": "true" },
          h("label", { text: "Leave this empty" }),
          honeypot,
        ),
        state.hv
          ? h("p", {
              class: "tia-muted",
              text: "A manager confirms high-value appraisals within 1 business day. Your time is held until then.",
            })
          : null,
        submit,
        button("Back", function () {
          stepTimes();
        }),
      ),
      true,
    );
  }

  function stepResult(d) {
    var v = d.view || {};
    var requested = d.result === "requested";
    show(
      h(
        "div",
        { class: "tia-step" },
        h("h2", { text: requested ? "Request received" : "You're booked" }),
        h("p", {
          text: requested
            ? "Thanks! A manager will confirm your appraisal for " +
              (v.when || state.startLabel) +
              " within 1 business day."
            : "See you " + (v.when || state.startLabel) + ".",
        }),
        v.whatToBring
          ? h("p", { text: "What to bring: " + v.whatToBring })
          : null,
        h("p", {
          class: "tia-muted",
          text: "We've emailed you the details and a link to reschedule or cancel.",
        }),
        d.manageToken
          ? h("a", {
              class: "tia-btn",
              href: "?manage=" + encodeURIComponent(d.manageToken),
              text: "View or change this appointment",
            })
          : null,
      ),
      true,
    );
  }

  /* ── drop-off mode ───────────────────────────────────────────────────── */
  // The agreement is server text: every paragraph goes in through textContent
  // (h's "text"), never innerHTML.
  function agreementBox() {
    var a = state.config.agreement;
    return h(
      "div",
      {
        class: "tia-agreement",
        tabindex: "0",
        role: "region",
        "aria-label": "Drop-off agreement",
      },
      a.paragraphs.map(function (p, i) {
        return h(i === 0 ? "h3" : "p", { text: p });
      }),
    );
  }

  // kind = alert style of msg: "error" (default) or "ok" (neutral/success).
  function stepDropoffDetails(msg, kind) {
    var honeypot = h("input", {
      type: "text",
      name: "website",
      tabindex: "-1",
      autocomplete: "off",
    });
    var ack = h("input", {
      type: "text",
      id: "tia-ack",
      autocomplete: "off",
      maxlength: "120",
    });
    ack.value = state.ack;
    ack.addEventListener("input", function () {
      state.ack = ack.value;
    });
    var submit = button(
      "Register drop-off",
      function () {
        busy(submit, true);
        api("/dropoffs", {
          clientSubmissionId: state.submissionId,
          game: state.game,
          tier: state.tier,
          hv: state.hv,
          name: state.form.name,
          email: state.form.email,
          phone: state.form.phone,
          cardEstimate: state.form.cardEstimate,
          notes: state.form.notes,
          ackName: ack.value,
          agreementVersion: state.config.agreement.version,
          website: honeypot.value,
        }).then(function (r) {
          busy(submit, false);
          var d = r.data || {};
          if (r.status === 200) {
            state.submissionId = newId();
            state.ack = "";
            return stepDropoffResult(d);
          }
          if (d.result === "invalid") return stepDropoffDetails(d.message);
          if (d.result === "agreement_changed" && d.agreement) {
            state.config.agreement = d.agreement;
            state.ack = "";
            return stepDropoffDetails(
              "The agreement was just updated — please read it again and type your name to agree.",
            );
          }
          if (d.result === "email_cap")
            return stepDropoffDetails(
              "You already have " +
                d.max +
                " open appraisals or drop-offs with this email. " +
                callUsSentence() +
                " if you need another.",
            );
          if (d.result === "disabled") {
            state.config.dropoffsOnline = false;
            state.mode = "appointment";
            return stepDropoff(!state.forcedDropoff);
          }
          stepDropoffDetails(problem(r.status));
        });
      },
      "primary",
    );
    show(
      h(
        "form",
        {
          class: "tia-step",
          novalidate: true,
          onsubmit: function (e) {
            e.preventDefault();
          },
        },
        h("h2", { text: "Drop off your cards" }),
        h("p", {
          class: "tia-summary",
          text:
            gameName() +
            " · " +
            tierFor(state.tier).label +
            (state.hv ? " · high-value" : ""),
        }),
        msg ? alertBox(msg, kind) : null,
        h("p", {
          text: "Register now, then bring your cards in anytime during store hours. We'll give you a tag number and email your quote within a few days.",
        }),
        field("name", "Full name", "text", {
          autocomplete: "name",
          maxlength: "120",
          required: true,
        }),
        field("email", "Email", "email", {
          autocomplete: "email",
          required: true,
        }),
        field("phone", "Phone", "tel", { autocomplete: "tel", required: true }),
        field("cardEstimate", "Roughly how many cards? (optional)", "text", {
          maxlength: "60",
        }),
        field("notes", "Anything we should know? (optional)", "textarea", {
          maxlength: "1000",
          rows: "3",
        }),
        h(
          "div",
          { class: "tia-hp", "aria-hidden": "true" },
          h("label", { text: "Leave this empty" }),
          honeypot,
        ),
        h("p", { class: "tia-summary", text: "Drop-off agreement" }),
        agreementBox(),
        h("label", { for: "tia-ack", text: "Type your full name to agree" }),
        ack,
        submit,
        button("Back", function () {
          stepAbout();
        }),
      ),
      true,
    );
  }

  // d may be the bare honeypot reply ({result:"registered"}): no view, no token.
  function stepDropoffResult(d) {
    var v = d.view || {};
    var toBring = v.whatToBring || state.config.whatToBring;
    show(
      h(
        "div",
        { class: "tia-step" },
        h("h2", { text: "You're registered" }),
        h("p", {
          text: "Bring your cards in anytime during store hours. We'll check them in, give you a tag number, and email your quote.",
        }),
        toBring ? h("p", { text: "What to bring: " + toBring }) : null,
        h("p", {
          class: "tia-muted",
          text: "We've emailed you a confirmation with a link to view or cancel this registration.",
        }),
        d.manageToken
          ? h("a", {
              class: "tia-btn",
              href: "?manage=" + encodeURIComponent(d.manageToken),
              text: "View this drop-off",
            })
          : null,
      ),
      true,
    );
  }

  // kind = alert style of notice: "ok" (default) or "error".
  function dropoffView(v, notice, kind) {
    var q = v.quote;
    var rows = [];
    if (v.tag) rows.push(h("dt", { text: "Tag" }), h("dd", { text: v.tag }));
    rows.push(h("dt", { text: "Status" }), h("dd", { text: v.statusLabel }));
    rows.push(
      h("dt", { text: "Cards" }),
      h("dd", {
        text:
          v.gameName +
          " · " +
          v.tierLabel +
          (v.boxCount
            ? " · " + v.boxCount + " box" + (v.boxCount === 1 ? "" : "es")
            : ""),
      }),
    );
    if (v.status === "checked_in" && v.dueLabel)
      rows.push(h("dt", { text: "Quote by" }), h("dd", { text: v.dueLabel }));
    var quoteBlock = null;
    if (q) {
      quoteBlock = h(
        "div",
        { class: "tia-quote" },
        h("h3", { text: "Your quote" }),
        // Once decided, show only what was decided (never both offers).
        v.decision === "cash" && q.cashCents !== null
          ? h("p", { text: "You accepted cash: " + money(q.cashCents) })
          : null,
        v.decision === "credit" && q.creditCents !== null
          ? h("p", {
              text: "You accepted store credit: " + money(q.creditCents),
            })
          : null,
        v.decision === "decline"
          ? h("p", { text: "You declined this quote." })
          : null,
        !v.decision && q.cashCents !== null
          ? h("p", { text: "Cash: " + money(q.cashCents) })
          : null,
        !v.decision && q.creditCents !== null
          ? h("p", { text: "Store credit: " + money(q.creditCents) })
          : null,
        q.note ? h("p", { class: "tia-muted", text: q.note }) : null,
        v.status === "quoted" && q.expiresLabel
          ? h("p", {
              class: "tia-muted",
              text: "Valid until " + q.expiresLabel,
            })
          : null,
      );
    }
    var actions = null;
    if (v.canDecide && q) {
      actions = h(
        "div",
        { class: "tia-actions" },
        q.cashCents !== null
          ? button(
              "Accept cash " + money(q.cashCents),
              function () {
                dropoffConfirm(
                  v,
                  "accept_cash",
                  "Accept cash of " + money(q.cashCents) + "?",
                );
              },
              "primary",
            )
          : null,
        q.creditCents !== null
          ? button(
              "Accept store credit " + money(q.creditCents),
              function () {
                dropoffConfirm(
                  v,
                  "accept_credit",
                  "Accept store credit of " + money(q.creditCents) + "?",
                );
              },
              "primary",
            )
          : null,
        button(
          "Decline",
          function () {
            dropoffConfirm(
              v,
              "decline",
              "Decline this quote? Your cards will be ready for pickup.",
            );
          },
          "danger",
        ),
      );
    } else if (v.canCancel) {
      actions = h(
        "div",
        { class: "tia-actions" },
        button(
          "Cancel registration",
          function () {
            dropoffConfirm(v, "cancel", "Cancel this drop-off registration?");
          },
          "danger",
        ),
      );
    }
    var next = null;
    if (v.status === "accepted")
      next = h("p", {
        text: "Stop by during store hours and we'll complete it.",
      });
    if (
      (v.status === "declined" || v.status === "expired") &&
      v.pickupDeadlineLabel
    )
      next = h("p", {
        text:
          "Your cards are ready for pickup during store hours — please collect them by " +
          v.pickupDeadlineLabel +
          ".",
      });
    show(
      h(
        "div",
        { class: "tia-step" },
        h("h2", { text: "Your drop-off" }),
        notice ? alertBox(notice, kind || "ok") : null,
        h("dl", { class: "tia-dl" }, rows),
        quoteBlock,
        next,
        actions,
      ),
      true,
    );
  }

  function dropoffConfirm(v, action, question) {
    var yes = button(
      "Yes, confirm",
      function () {
        busy(yes, true);
        var body = { t: manageToken, action: action };
        if (action !== "cancel") body.revision = v.quote.revision;
        api("/manage", body).then(function (r) {
          var d = r.data || {};
          if (r.status === 404) return manageInactive();
          if (r.status === 200 && d.view)
            return dropoffView(
              d.view,
              action === "cancel"
                ? "Your registration is cancelled."
                : action === "decline"
                  ? "Quote declined. We've emailed you the pickup details."
                  : "Accepted — we've emailed you the next steps.",
            );
          // Refused: the server sends the current view with every refusal.
          if (d.view) {
            if (d.view.status === "expired")
              return dropoffView(
                d.view,
                "This quote has expired. " +
                  callUsSentence() +
                  " and we'll requote.",
                "error",
              );
            if (d.result === "quote_changed")
              return dropoffView(
                d.view,
                "Your quote was just updated — please review it again.",
                "error",
              );
            return dropoffView(
              d.view,
              d.result === "too_late"
                ? "This can't be changed online any more — " + callUs() + "."
                : "This was already changed — " +
                    callUs() +
                    " if you have questions.",
              "error",
            );
          }
          dropoffView(v, problem(r.status), "error");
        });
      },
      action === "decline" || action === "cancel" ? "danger" : "primary",
    );
    show(
      h(
        "div",
        { class: "tia-step" },
        h("h2", { text: question }),
        h(
          "div",
          { class: "tia-actions" },
          yes,
          button("Back", function () {
            dropoffView(v);
          }),
        ),
      ),
      true,
    );
  }

  /* ── manage mode ─────────────────────────────────────────────────────── */
  function manageView(v, notice) {
    var live = v.status === "booked" || v.status === "requested";
    show(
      h(
        "div",
        { class: "tia-step" },
        h("h2", { text: "Your appraisal" }),
        notice ? alertBox(notice, "ok") : null,
        h(
          "dl",
          { class: "tia-dl" },
          h("dt", { text: "When" }),
          h("dd", { text: v.when }),
          h("dt", { text: "What" }),
          h("dd", {
            text:
              v.gameName +
              " · " +
              v.tierLabel +
              (v.highValue ? " · high-value" : ""),
          }),
          h("dt", { text: "Status" }),
          h("dd", { text: v.statusLabel }),
        ),
        live && v.whatToBring
          ? h("p", { text: "What to bring: " + v.whatToBring })
          : null,
        v.canChange
          ? h(
              "div",
              { class: "tia-actions" },
              button(
                "Reschedule",
                function () {
                  manageReschedule(v);
                },
                "primary",
              ),
              button(
                "Cancel appointment",
                function () {
                  manageConfirmCancel(v);
                },
                "danger",
              ),
            )
          : live
            ? h("p", {
                text:
                  "It's too close to your appointment to change it online — " +
                  callUs() +
                  ".",
              })
            : v.status === "cancelled"
              ? h("a", {
                  class: "tia-btn",
                  href: window.location.pathname,
                  text: "Book a new appraisal",
                })
              : null,
      ),
      true,
    );
  }

  function handleManageResult(r, v) {
    var d = r.data || {};
    if (r.status === 200)
      return manageView(
        d.view,
        v === "cancel"
          ? "Your appointment is cancelled. We've emailed you a confirmation."
          : d.view && d.view.status === "requested"
            ? "Done — we've emailed you the updated details. A manager still needs to confirm the new time."
            : "Done — we've emailed you the updated details and calendar invite.",
      );
    if (r.status === 404) return manageInactive();
    if (d.result === "too_late")
      return manageView(
        d.view,
        "It's too close to your appointment to change it online — " +
          callUs() +
          ".",
      );
    if (d.result === "conflict")
      return manageView(
        d.view,
        "This appointment was already changed. Here is the latest.",
      );
    show(h("div", null, alertBox(problem(r.status))));
  }

  function manageConfirmCancel(v) {
    var yes = button(
      "Yes, cancel it",
      function () {
        busy(yes, true);
        api("/manage", { t: manageToken, action: "cancel" }).then(function (r) {
          handleManageResult(r, "cancel");
        });
      },
      "danger",
    );
    show(
      h(
        "div",
        { class: "tia-step" },
        h("h2", { text: "Cancel your appraisal?" }),
        h("p", { text: v.gameName + " · " + v.when }),
        h(
          "div",
          { class: "tia-actions" },
          yes,
          button("Keep it", function () {
            manageView(v);
          }),
        ),
      ),
      true,
    );
  }

  function manageReschedule(v, msg, nearest) {
    api("/manage?t=" + encodeURIComponent(manageToken) + "&slots=1").then(
      function (r) {
        if (r.status === 404) return manageInactive();
        if (r.status !== 200)
          return show(h("div", null, alertBox(problem(r.status))));
        var days = r.data.days || [];
        var choose = function (start, label) {
          manageConfirmMove(v, start, label);
        };
        show(
          h(
            "div",
            { class: "tia-step" },
            h("h2", { text: "Pick a new time" }),
            h("p", { class: "tia-muted", text: "Currently: " + v.when }),
            msg ? alertBox(msg) : null,
            nearest && nearest.length
              ? h(
                  "div",
                  { class: "tia-times" },
                  nearest.map(function (n) {
                    return h("button", {
                      type: "button",
                      class: "tia-chip tia-chip--time",
                      text: n.label,
                      onclick: function () {
                        choose(n.start, n.label);
                      },
                    });
                  }),
                )
              : null,
            days.length
              ? picker(days, choose)
              : h("p", {
                  text:
                    "There are no other openings right now — " + callUs() + ".",
                }),
            button("Back", function () {
              manageView(v);
            }),
          ),
          true,
        );
      },
    );
  }

  function manageConfirmMove(v, start, label) {
    var yes = button(
      "Yes, move it",
      function () {
        busy(yes, true);
        api("/manage", {
          t: manageToken,
          action: "reschedule",
          start: start,
        }).then(function (r) {
          var d = r.data || {};
          if (d.result === "slot_taken")
            return manageReschedule(
              v,
              "Sorry — that time was just taken.",
              d.nearest,
            );
          handleManageResult(r, "reschedule");
        });
      },
      "primary",
    );
    show(
      h(
        "div",
        { class: "tia-step" },
        h("h2", { text: "Move your appraisal?" }),
        h("p", { text: "From " + v.when + " to " + label + "." }),
        h(
          "div",
          { class: "tia-actions" },
          yes,
          button("Back", function () {
            manageReschedule(v);
          }),
        ),
      ),
      true,
    );
  }

  function manageInactive() {
    show(
      h(
        "div",
        { class: "tia-step" },
        h("h2", { text: "This link is no longer active" }),
        h("p", {
          text:
            "The appointment or drop-off has finished, or the link was replaced by a newer email. Please " +
            callUs().replace(/^please /, "") +
            ".",
        }),
        h("a", {
          class: "tia-btn",
          href: window.location.pathname,
          text: "Start a new appraisal",
        }),
      ),
    );
  }

  /* ── boot ────────────────────────────────────────────────────────────── */
  api("/config").then(function (cfg) {
    if (cfg.status !== 200)
      return show(h("div", null, alertBox(problem(cfg.status))));
    state.config = cfg.data;
    if (!manageToken) return stepAbout();
    api("/manage?t=" + encodeURIComponent(manageToken)).then(function (r) {
      if (r.status === 404) return manageInactive();
      if (r.status !== 200)
        return show(h("div", null, alertBox(problem(r.status))));
      if (r.data.kind === "dropoff") return dropoffView(r.data.view);
      manageView(r.data.view);
    });
  });
})();
